export default () => ({
  showModal: false,
  info: false
})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/schedule/resources/data.js